{
  "help": "Súgó",
  "info": "Információ"
}
